<template>
    <Sync></Sync>
</template>
<script>
import Sync from './Sync.vue';

export default {
    name: 'storybook',
    components: {
        Sync,
    },
}
</script>